import { ReactNode } from 'react'

import cn from 'classnames'

import styles from './styles.module.scss'

type PopupSubtitle = {
  children: ReactNode | ReactNode[]
  className?: string
}

const PopupSubtitle = ({ children, className }: PopupSubtitle) => {
  return <p className={cn(styles.popup__subtitle, className)}>{children}</p>
}

export default PopupSubtitle
